// extracted by mini-css-extract-plugin
export default {"dragHandle":"styles_dragHandle__S25T0","dragHandleIcon":"styles_dragHandleIcon__Vymah","systemContent":"styles_systemContent__SnBIt","sortableHelper":"styles_sortableHelper__lQSy-"};